// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
import type { LoadedMachine } from '@core/machine'
import { EV_SWITCH_CLOSED, EV_SWITCH_OPENED } from '@core/sim/events'
import { BALL_RADIUS } from '@core/sim/constants'
import type { Ramp } from '@core/sim/devices/Ramp'
import type { WireGuide } from '@core/sim/devices/WireGuide'
import type { ComponentLightingState } from './componentLightingState'
import { createPathQuery } from '@core/sim/Path'
const query = createPathQuery()

/** Called by the non-consuming event tap while the event's ball pose is still authoritative. */
export function recordLightingEvent(state: ComponentLightingState, loaded: LoadedMachine,
  type: number, index: number, ballId: number, step: number, value: number): void {
  const device = loaded.world.devices[index]
  if (device === undefined) return
  state.event(type, device.id, step, value)
  if (!['rampSurface', 'wireGuide'].includes(device.kind)) return
  if (type !== (device.kind === 'wireGuide' ? EV_SWITCH_OPENED : EV_SWITCH_CLOSED)) return
  const path = (device as Ramp | WireGuide).path, n = path.sampleCount - 1
  const ball = loaded.world.balls[ballId]
  if (ball === undefined || n < 1) return
  const tx = path.xs[n]! - path.xs[n - 1]!, ty = path.ys[n]! - path.ys[n - 1]!
  path.project(ball.x, ball.y, query)
  const runtime = device as Ramp | WireGuide
  const half = device.kind === 'wireGuide' ? (device as WireGuide).captureRadius : (device as Ramp).width / 2
  // Entry, fallback from the mouth, and departure over the side cannot satisfy this forward exit.
  if (query.s >= path.length - BALL_RADIUS && query.distance <= half + BALL_RADIUS
    && ball.layer === runtime.toLayer && ball.vx * tx + ball.vy * ty > 0) {
    state.pathCompleted(device.id, step)
  }
}
